import Row from '@components/Row';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import MapPin from '@icons/MapPin';
import useCalculatedCart from '@store/cart/hooks/useCalculatedCart';

import styles from './styles.module.scss';

function ShopLocation() {
  const { shopName } = useCalculatedCart();
  return (
        <Row className={styles.container}
             spacing={4}
             align='center'>
            <MapPin color={colors.gray6}/>
            <Row>
                <TextUnderline>
                    <Text size='lg' fontWeight='bold'>{shopName}</Text>
                </TextUnderline>
                <Text size='lg'>
                    에서 주문합니다
                </Text>
            </Row>
        </Row>
  );
}

export default ShopLocation;
